module.exports = __webpack_public_path__ + "static/media/undraw_phone_call_grmk.0f2fb1f6.svg";